export default function () {
  return {
    currentRoute: null
  };
}